// Auto-generated for /pages/x-ray-inspection during Magento → Shopify migration.
// Loaded with <script defer> so DOM is ready before this runs.

(function() {
    'use strict';

    var formKeyField = document.getElementById('xray-form-key');
    if (formKeyField) {
      var match = document.cookie.match(/form_key=([^;]+)/);
      if (match) {
        formKeyField.value = match[1];
      }
    }
  })();